export default "__VITE_ASSET__BCJKqLT4__"